import React from 'react';
import PropTypes from 'prop-types';
import {GoogleMap, Marker, InfoWindow} from '@react-google-maps/api';

class StockistsMap extends React.Component {
  constructor(props) {
    super(props);

    this.handleToggleInfo = this.handleToggleInfo.bind(this);

    this.state = {
      activeTheme: window.theme.activeTheme,
      activeKey: null,
    };
  }

  handleToggleInfo(key) {
    this.setState({
      activeKey: key,
    });
  }

  render() {
    const {activeKey} = this.state;
    const {stockists, center} = this.props;
    /* eslint-disable */
    const mapStyles = [
      {
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#e8e8e8'
          }
        ]
      },
      {
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#000000'
          }
        ]
      },
      {
        'elementType': 'labels.text.stroke',
        'stylers': [
          {
            'color': 'transparent'
          }
        ]
      },
      {
        'featureType': 'administrative.land_parcel',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#bdbdbd'
          }
        ]
      },
      {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#eeeeee'
          }
        ]
      },
      {
        'featureType': 'poi',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#757575'
          }
        ]
      },
      {
        'featureType': 'poi.park',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#e5e5e5'
          }
        ]
      },
      {
        'featureType': 'poi.park',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#9e9e9e'
          }
        ]
      },
      {
        'featureType': 'road',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#ffffff'
          }
        ]
      },
      {
        'featureType': 'road.arterial',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#757575'
          }
        ]
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#ffffff'
          }
        ]
      },
      {
        'featureType': 'road.highway',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#616161'
          }
        ]
      },
      {
        'featureType': 'road.local',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#9e9e9e'
          }
        ]
      },
      {
        'featureType': 'transit.line',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#e5e5e5'
          }
        ]
      },
      {
        'featureType': 'transit.station',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#eeeeee'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#cddad8'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#9e9e9e'
          }
        ]
      }
    ];
    /* eslint-enable */

    return (
      <GoogleMap
        id="stockists-map"
        zoom={6}
        center={{
          lat: center.lat,
          lng: center.lng,
        }}
        options={{
          styles: mapStyles,
          disableDefaultUI: true,
          zoomControl: true,
        }}
      >
          {
            stockists.map((stockist, i) => {
              if (stockist && stockist.lat !== '' && stockist.lng && stockist.lng !== '') {
                return (
                  <Marker
                    key={i}
                    position={{lat: stockist.lat, lng: stockist.lng}}
                    icon={stockist.type.trim() === 'accessories only' ? window.stockistsMarkers.mountsAccessories : window.stockistsMarkers[stockist.type]}
                    onClick={() => this.handleToggleInfo(i)}
                  >
                    { activeKey === i &&
                      <InfoWindow
                        position={{lat: stockist.lat, lng: stockist.lng}}
                        onCloseClick={() => this.handleToggleInfo(null)}
                      >
                        <div>
                          <div>{stockist.name}</div>
                          <div>{stockist.address}</div>
                        </div>
                      </InfoWindow>
                    }
                  </Marker>
                );
              }
              return true;
            })
          }
      </GoogleMap>
    );
  }
}

StockistsMap.propTypes = {
  stockists: PropTypes.array,
  center: PropTypes.object,
};

export default StockistsMap;
